import React from "react";
import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="border-t border-line mt-16">
      <div className="max-w-5xl mx-auto px-4 lg:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-mute">
          © {new Date().getFullYear()} MmeValentine — Activation LinkedIn par IA
        </p>
        <nav className="flex items-center gap-5">
          <Link to="/pricing" className="text-xs text-mute hover:text-ink transition-colors">
            Tarifs
          </Link>
          <Link to="/cgu" className="text-xs text-mute hover:text-ink transition-colors">
            CGU
          </Link>
          <Link to="/confidentialite" className="text-xs text-mute hover:text-ink transition-colors">
            Confidentialité
          </Link>
          <a
            href="mailto:support@activate.mmevalentine.com"
            className="text-xs text-mute hover:text-ink transition-colors"
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
}
